module.exports = __webpack_public_path__ + "img/section-number-checkout-outline.b65e5576.svg";